import withConfigTransport from '../../services/config-transport/withConfigTransport'
import VaAffix from './VaAffix.vue'

export default withConfigTransport(VaAffix)
